export default [
  {
    label: '長輩生病',
    value: 'elderSick',
  },
  {
    label: '長輩過世',
    value: 'elderPassedAway',
  },
  {
    label: '餐點不滿意',
    value: 'mealDissatified',
  },
  {
    label: '其他',
    value: 'others',
  },
];
